import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import StockApi from "../common/Apis/StockApi";
import EditStock from "../common/Models/GoodInward/EditStock";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const ProductionStockList = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Stocks, setStocks] = React.useState([]);

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    StockApi.ListStockLevel(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setStocks(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    StockApi.ListStockLevel(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setStocks(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const getStock = useCallback(() => {
    StockApi.ListStockLevel(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setStocks(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getStock();
    PageLoading();
  }, [getStock, PageLoading]);



  const handleRemovefilterStock = (FiltergetStockIndex) => {
    const newfilterStock = [...filterStock];
    newfilterStock.splice(FiltergetStockIndex, 1);
    setFilterStock(newfilterStock);
    if (FiltergetStockIndex == 0) {
      getStock();
    }
  };
  const handleClear = () => {
    getStock();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterStock([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterStock, setFilterStock] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);
  const handleGoBack = () => {
    navigate(-1);
  };
  const handleAddfilterStock = () => {
    setFilterStock([
      ...filterStock,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterStock
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
      "componentCode=STOCK&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setStocks(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (FiltergetStockIndex, value) => {
    const newfilterStock = [...filterStock];
    newfilterStock[FiltergetStockIndex].title = value;
    setFilterStock(newfilterStock);
  };
  const handleChangeAnswertype = (FiltergetStockIndex, value) => {
    const newfilterStock = [...filterStock];
    newfilterStock[FiltergetStockIndex].answerType = value;
    setFilterStock(newfilterStock);
  };

  const handleChangename = (FiltergetStockIndex, value) => {
    const newfilterStock = [...filterStock];
    newfilterStock[FiltergetStockIndex].name = value;
    setFilterStock(newfilterStock);
  };

  const paginatedData = Stocks;

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">

          <td style={{ width: "12%" }} className="pt-3">
            {item?.productionDTO?.batchCode}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
            {item?.productionDTO?.unit}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
            {item?.qtyInStock}
          </td>
          <td style={{ width: "10%" }} className="pt-3 ">
            {item?.costOfStock}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {item?.actualStock}
          </td>

          {/* <td style={{ width: "8%" }}>
            <div className="d-flex ">
              <Link
                onClick={() => handleOpenEditModal(item.id)}
                className="btn btn-primary btn-save table-action icon-center w-100"
              >
                <EditOutlined />
                Edit
              </Link>
              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Stock ?"
                okText="Yes"
                onConfirm={() => handleDeleteStock(item.id)}
                placement="topRight"
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className="btn btn-primary btn-back table-action icon-center mx-1"
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td> */}
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={6} className="text-center ">
            <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
            />
            <br />
            {/* <Button
              className="btn btn-primary btn-save m-0 my-2 "
              onClick={handleOpenAddModal}
            >
              Add Stock
            </Button> */}
          </td>
        </tr>
      );
    }
  };

  const handleDeleteStock = (StockID) => {
    StockApi.DeleteStock(StockID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getStock();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });

  };
  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate.split(" ");

    const capitalizedMonth = month.toUpperCase();

    return `${day} ${capitalizedMonth} ${year}`;
  }


  const [modalAddVisible, setModalAddVisible] = useState(false);

  const handleOpenAddModal = () => {
    setModalAddVisible(true);
  };
  const handleAddCloseModal = () => {
    setModalAddVisible(false);
  };


  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");

  const handleOpenEditModal = (StockID) => {
    StockApi.SingleStock(StockID)
      .then((response) => {
        console.log(response);
        setModalEditData(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
    setModalEditVisible(true);
  };
  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterStock.map((input, filterStockIndex) => (
                    <div key={filterStockIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterStockIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterStockIndex, value)
                              }
                              options={[
                                {
                                  value: "unitOfMeasurement1",
                                  label: "UOM 1",
                                },
                                {
                                  value: "unitOfMeasurement2",
                                  label: "UOM 2",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item
                            name={`type${filterStockIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(
                                  filterStockIndex,
                                  value
                                )
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={5}>
                          <Form.Item
                            name={`name${filterStockIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterStockIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterStockIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterStock}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterStock(
                                      filterStockIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                <Link
                  className="btn btn-primary btn-back m-0 my-2 "
                  onClick={handleGoBack}
                >
                  Back
                </Link>
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Batch Code</th>
                  <th>Unit</th>
                  <th>Qty In Stock</th>
                  <th>Cost Of Stock</th>
                  <th>Actual Stock</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>

        {modalEditVisible && <EditStock
          visible={modalEditVisible}
          onClose={handlEditeCloseModal}
          ProductDetails={modalEditData}
        />
        }

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default ProductionStockList;
